import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { SortByType } from '../../../../types/events.types';

type Store = {
  reset: () => void;
  selectedViewBy: null | SortByType;
  setSelectedViewBy: (payload: null | SortByType) => void;
};

export const eventSelectedTabStore = create<Store>()(
  persist(
    (set) => ({
      selectedViewBy: null,
      setSelectedViewBy: (payload) => set({ selectedViewBy: payload }),
      reset: () => set({ selectedViewBy: null }),
    }),
    {
      name: 'events-view-by-storage',
    },
  ),
);
